/**
 * A full-page error message to show when the user attempts to access something
 * that they don't have permission to see.
 */
import {useEffect} from "react";

import {reload} from "@khan/urls";

import FullPageSpinner from "./full-page-spinner.tsx";

export default function ReloadPage() {
    useEffect(reload, []);
    return <FullPageSpinner />;
}
